import type { EpubProgressEntry, ReadingProgressEntry } from '../domain/entities/types';

export const EPUB_EQUIVALENT_PAGE_TOTAL = 400;

export const equivalentEpubPage = (percent: number): number => {
  if (percent >= 100) return EPUB_EQUIVALENT_PAGE_TOTAL;
  return Math.floor((Math.max(0, percent) / 100) * EPUB_EQUIVALENT_PAGE_TOTAL);
};

export type EpubEquivalentPageContribution = {
  entry: EpubProgressEntry;
  deltaPages: number;
};

export const epubEquivalentPageContributions = (
  entries: readonly ReadingProgressEntry[]
): EpubEquivalentPageContribution[] => {
  const effectiveEntries = entries
    .filter((entry): entry is EpubProgressEntry => entry.kind === 'epub' && !entry.supersededByEntryId)
    .sort((left, right) => left.recordedAt.localeCompare(right.recordedAt)
      || left.createdAt.localeCompare(right.createdAt)
      || left.id.localeCompare(right.id));
  const highWaterByDocument = new Map<string, number>();

  return effectiveEntries.map((entry) => {
    const documentKey = `${entry.bookId}:${entry.documentSha256}`;
    const previousHighWater = highWaterByDocument.get(documentKey) ?? 0;
    const nextHighWater = Math.max(previousHighWater, entry.previousPercent, entry.currentPercent);
    highWaterByDocument.set(documentKey, nextHighWater);

    return {
      entry,
      deltaPages: equivalentEpubPage(nextHighWater) - equivalentEpubPage(previousHighWater)
    };
  });
};
